type DateFromGraph =
  `${number}${number}${number}${number}-${number}${number}-${number}${number}`;

const isStipendExpired = (expiresAt: string | null) => {
  if (!expiresAt) {
    return false;
  }

  const now = new Date();
  const expirationDate = new Date(expiresAt);

  return now > expirationDate;
};

const isStipendUpcoming = (startsAt: string) => {
  const now = new Date();
  const startsAtDate = new Date(startsAt);

  return now < startsAtDate;
};

export { isStipendExpired, isStipendUpcoming };
export type { DateFromGraph };
